export function registerServiceWorker(version?: string) {
    if (typeof window === 'undefined') {
        return;
    }

    const swSupported = 'serviceWorker' in navigator;
    if (!swSupported) {
        return;
    }

    const baseHref = (document.querySelector('base')?.getAttribute('href') || '/').replace(/\/+$/, '/');
    const swUrl = `${baseHref}ngx2-service-worker.js`;

    const preflightCheck = async () => {
        try {
            const resp = await fetch(swUrl, { cache: 'no-cache', redirect: 'follow' });
            if (resp.status !== 200) {
                console.warn('[SW] Preflight: ngx-service-worker.js não retornou 200. Registro pode falhar.');
            }
            return true;
        } catch (e) {
            console.warn('[SW] Preflight: falha ao buscar service-worker.js:', e);
            return false;
        }
    };

    window.addEventListener('load', async () => {
        await preflightCheck();

        navigator.serviceWorker
            .register(swUrl)
            .then(async (registration) => {
                if (registration.waiting) {
                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                }

                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    if (!newWorker) {
                        return;
                    }

                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            newWorker.postMessage({ type: 'SKIP_WAITING' });
                        }
                    });
                });

                const currentVersion = localStorage.getItem('PROJECT_VERSION');

                if (version && currentVersion !== version) {
                    console.log(currentVersion, version);
                    localStorage.setItem('PROJECT_VERSION', version);

                    // TODO: Remove old bundles files

                    const keep = new Set(['bet-plus-web-js-chunks-v1', 'assets-runtime', 'image-cache', 'font-cache', 'api-cache']);
                    const keys = await caches.keys();
                    await Promise.all(keys.filter((name) => !keep.has(name)).map((name) => caches.delete(name)));
                }

                // let refreshing = false;
                // let hadControllerAtStart = !!navigator.serviceWorker.controller;
                // navigator.serviceWorker.addEventListener('controllerchange', () => {
                //   if (!hadControllerAtStart) {
                //     hadControllerAtStart = true;
                //     return;
                //   }
                //
                //   if (refreshing) {
                //     return;
                //   }
                //   refreshing = true;
                //   window.location.reload();
                // });

                navigator.serviceWorker.ready.catch((e) => console.warn('[SW] ready falhou:', e));

                setTimeout(() => {
                    registration.update().catch((e) => console.warn('[SW] registration.update() falhou:', e));
                }, 5000);
            })
            .catch((err) => {
                console.warn('[SW] Falha ao registrar SW:', err);
                console.warn(
                    '[SW] Dicas: 1) service-worker.js precisa existir e retornar 200; 2) precisa estar sob o mesmo host/escopo do app; 3) HTTPS (ou localhost); 4) evite redirecionamentos; 5) verifique MIME type: text/javascript.',
                );
            });
    });
}
